export default {
	UPDATE_SELECTED_JOB(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.selectedJob = payload;
	},
	UPDATE_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.jobs = payload;
	},
	UPDATE_DIAGNOSTIC_ID(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.diagnosticId = payload;
	},
	UPDATE_POLL_ID(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.custom.jobEvaluationPoll.pollId = payload;
	},
};



// WEBPACK FOOTER //
// ./src/modules/polls/store/custom/job-evaluation-poll/mutations.js